import React, { useEffect, useState } from 'react';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiFileText } from 'react-icons/fi';
import SoftBadge from 'components/common/SoftBadge';
// import SeccionModulosPaquete from '../SeccionModulosPaquete';
// import SeccionModulosPro from '../SeccionMoludosPro';

const SeccionServiciosRelacionados = ({
    licencias,
    idLicencia,

    // akasiaPOSWebPaquetes,
    // setAkasiaPOSWebPaquetes,

    setPolizasRelacionadas,
    polizasRelacionadas
}) => {

    const { token } = useToken();
    const { showErrorToast } = useToast();

    /*const [modulosExtraVinculados, setModulosExtraVinculados] = useState([]);*/
    // const [DescripcionPaqueteAkasiaPOS, setDescripcionPaqueteAkasiaPOS] = useState("");



    const [nubes, setNubes] = useState([]);



    /**
     * Obtiene los datos básicos de la licencia
     */
    const ObtenerDatosSeccionServicosRelacionados = async () => {


        try {
            // setCargando(true);
            const response = await fetch(`/api/licencia/ObtenerDatosServiciosRelacionados/?id=${idLicencia}`, {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("Datos Servicios Relacionados", ObjDetalles)

                //Polizas relacionadas
                setPolizasRelacionadas(ObjDetalles.table2);

                //Nubes relacionadas
                setNubes(ObjDetalles.table3);

                
              



                // if (ObjDetalles.table4[0]?.vDescripcionPaquete) {
                //     setDescripcionPaqueteAkasiaPOS(ObjDetalles.table4[0].vDescripcionPaquete);
                // }



                // // Modulos extra vinculados
                // if (ObjDetalles.table5 && ObjDetalles.table5.length > 0) {
                //     setModulosExtraVinculados(ObjDetalles.table5);
                // } else {
                //     setModulosExtraVinculados([]);
                // }


                if (licencias.idCatTipoLicencia == 3)
                    setNubes([]);
            }



            //if (data['table1'][0].idAkasiaPOSWebPaquetes) {
            //    setIdAkasiaPOSWebPaquetes(data['table1'][0].idAkasiaPOSWebPaquetes);
            //}
            //if (data['table1'][0].vCodigoPaqueteAkasiaPOS) {
            //    setCodigoPaqueteAkasiaPOS(data['table1'][0].vCodigoPaqueteAkasiaPOS);
            //}
            //if (data['table1'][0].vDescripcionPaquete) {
            //    setDescripcionPaqueteAkasiaPOS(data['table1'][0].vDescripcionPaquete);
            //}



        } catch (error) {
            showErrorToast(error.message);
            console.error('Error al obtener datos de la licencia:', error);
        } finally {
            //setCargando(false);
        }
    };



    useEffect(() => {
        ObtenerDatosSeccionServicosRelacionados();
    }, [idLicencia]);

    // Ocultar sección completa para AkasiaPOS (idCatTipoLicencia === 7)
    // Para revertir: quitar este if y restaurar ternarios en header y body
    if (licencias.idCatTipoLicencia === 7) return null;

    return (
        <Row className="g-3 mb-3">
            <Col lg={12}>
                <Card className="mt-3 fs--1">
                    <Card.Header className="border-bottom border-200">
                        {/* Título original con ternario:
                            {licencias.idCatTipoLicencia === 7
                                ? '' //'MÓDULOS INCLUIDOS EN EL ' + DescripcionPaqueteAkasiaPOS
                                : 'Servicios Adicionales Vinculados'} */}
                        <h5 className="mb-0">Servicios Adicionales Vinculados</h5>
                    </Card.Header>

                    <Card.Body>
                        <Row className="gx-3">
                            {polizasRelacionadas.map((poliza, index) => (
                                <Col key={index} md={6} xxl={4}>
                                    <div className="hover-bg-100 py-x1 text-center rounded-3 position-relative">
                                        <div className="icon-item icon-item-xl shadow-none mx-auto mt-x1 bg-soft-success">
                                            <FiFileText className="text-info fs-2" />
                                        </div>
                                        <h5 className="mt-3 mb-2">
                                            <Link to={`/polizas/detalle/${poliza.idPoliza}`} className="text-900 hover-primary stretched-link">
                                                {poliza.vNombreTipoPoliza}
                                            </Link>
                                        </h5>
                                        <h5 className="w-75 mx-auto text-600 mb-x1">Póliza {poliza.idPoliza}</h5>
                                        <h6>
                                            {poliza.dDiasFaltantes <= 0 && (
                                                <>
                                                    <img src="/img/polizaVencida.png" alt="vencida" />
                                                    <Badge bg="danger" className="me-2 dark__bg-dark">VENCIDA</Badge>
                                                </>
                                            )}
                                            {poliza.dDiasFaltantes > 60 && (
                                                <>
                                                    <img src="/img/polizaActiva.png" alt="activa" />
                                                    <SoftBadge bg="success" className="me-2 dark__bg-dark">
                                                        ACTIVA (restan {poliza.dDiasFaltantes} días)
                                                    </SoftBadge>
                                                </>
                                            )}
                                            {poliza.dDiasFaltantes <= 60 && poliza.dDiasFaltantes > 0 && (
                                                <>
                                                    <img src="/img/polizaPorVencer.png" alt="por vencer" />
                                                    <SoftBadge bg="warning" className="me-2 dark__bg-dark">
                                                        ACTIVA (restan {poliza.dDiasFaltantes} días)
                                                    </SoftBadge>
                                                </>
                                            )}
                                        </h6>
                                        <h6><span>Vencimiento: {poliza.dFechaVencimiento}</span></h6>
                                    </div>
                                </Col>
                            ))}
                            {nubes.map((nube, index) => (
                                <Col key={`nube-${index}`} md={6} xxl={4}>
                                    <div className="hover-bg-100 py-x1 text-center rounded-3 position-relative">
                                        <div className="icon-item icon-item-xl shadow-none mx-auto mt-x1 bg-soft-success">
                                            <FiFileText className="text-info fs-2" />
                                        </div>
                                        <h5 className="mt-3 mb-2">
                                            <Link to={`/licencias/detalle/${nube.idLicencia}`} className="text-900 hover-primary stretched-link">
                                                Nube Akasia
                                            </Link>
                                        </h5>
                                        <h5 className="w-75 mx-auto text-600 mb-x1">{nube.idLicencia}</h5>
                                        <h6>
                                            {nube.dDiasFaltantes <= 0 ? (
                                                <>
                                                    <img src="/img/nubeVencida.png" alt="nube vencida" />
                                                    <Badge bg="danger" className="me-2 dark__bg-dark">VENCIDA</Badge>
                                                </>
                                            ) : (
                                                <>
                                                    <img src="/img/nubeActiva.png" alt="nube activa" />
                                                    <SoftBadge bg="success" className="me-2 dark__bg-dark">
                                                        ACTIVA (restan {nube.dDiasFaltantes} días)
                                                    </SoftBadge>
                                                </>
                                            )}
                                        </h6>
                                        <h6><span>Vencimiento: {nube.dFinLicenciaUso}</span></h6>
                                    </div>
                                </Col>
                            ))}

                            {/* {licencias.idCatTipoLicencia == 7 && (
                                <SeccionModulosPaquete
                                    idLicencia={idLicencia}


                                    setModulosExtraVinculados={setModulosExtraVinculados}

                                    akasiaPOSWebPaquetes={akasiaPOSWebPaquetes}
                                    setAkasiaPOSWebPaquetes={setAkasiaPOSWebPaquetes}

                                    setDescripcionPaqueteAkasiaPOS={setDescripcionPaqueteAkasiaPOS}
                                    DescripcionPaqueteAkasiaPOS={DescripcionPaqueteAkasiaPOS }
                                />
                            )} */}
                        </Row>
                    </Card.Body>

                    <Card.Footer className="border-top border-200">
                        {/*licencias.idCatTipoLicencia !== 3 && (
                            <SeccionModulosPro
                                idLicencia={licencias.idLicencia}
                                idCatTipoLicencia={licencias.idCatTipoLicencia}
                                setModulosExtraVinculados={setModulosExtraVinculados}
                                modulosExtraVinculados={modulosExtraVinculados}
                            />
                        )*/}
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    );
};

SeccionServiciosRelacionados.propTypes = {
    licencias: PropTypes.shape({
        idCatTipoLicencia: PropTypes.number,
        idLicencia: PropTypes.number,
    }).isRequired,
    idLicencia: PropTypes.string.isRequired,
    // akasiaPOSWebPaquetes: PropTypes.array.isRequired,
    // setAkasiaPOSWebPaquetes: PropTypes.func.isRequired,
    setPolizasRelacionadas: PropTypes.func.isRequired,
    polizasRelacionadas: PropTypes.array.isRequired
};

export default SeccionServiciosRelacionados;
